// V2S200D bone conduction sensor behind the Realtek DMIC input (firmware AUDIO1_DMIC=ON).
// The MQTT gain command maps realtek_gain -> dmic_gain and realtek_volume -> adc_vol on these devices.

export const DMIC_TYPE = 'dmic_v2s200d';

export const DMIC_GAIN_OPTIONS = [
  { value: 0, label: '0 dB' },
  { value: 1, label: '12 dB' },
  { value: 2, label: '24 dB' },
  { value: 3, label: '36 dB' },
];

export const ADC_VOL_MIN = 0;
export const ADC_VOL_MAX = 127;
export const ADC_VOL_UNITY = 47; // 0 dB

// Sensor clips at ~25.1 g peak with 0 dB codec gain (17.8 g RMS for a sine)
const CLIP_PEAK_G = 25.1;
const CLIP_RMS_G = 17.8;

export const adcVolDb = (adcVol) => (adcVol - ADC_VOL_UNITY) * 0.375;

export const dmicTotalGainDb = (dmicGain, adcVol) =>
  (Number(dmicGain) || 0) * 12 + adcVolDb(adcVol ?? ADC_VOL_UNITY);

export const clipPeakG = (totalGainDb) => CLIP_PEAK_G * 10 ** (-totalGainDb / 20);

export const clipRmsG = (totalGainDb) => CLIP_RMS_G * 10 ** (-totalGainDb / 20);

export const formatG = (g) => (g < 1
  ? `${Number((g * 1000).toPrecision(3))} mg`
  : `${Number(g.toPrecision(3))} g`);

export const formatDb = (db) => `${db > 0 ? '+' : ''}${db.toFixed(1)} dB`;
